import { observer } from "mobx-react-lite";
import React, { createRef, RefObject, useMemo } from "react";
import { classNames } from "src/common/classNames";
import { applyOrderStd, TableStore } from "src/components/tables/TableStore";
import {
  PropsATVDynamic,
  TableSelectionCheckbox,
} from "src/pages/EntityFiltersPage/AsyncTableView";
import { visibleFixedLeft } from "src/components/tables/ColumnPoor";
import { ATVFreezeLine } from "../ATVFreezeLine/ATVFreezeLine";
import { ATVHeaderCellStd } from "./ATVHeaderCellStd";
import styles from "./ATVHeaderStd.module.less";

export type PropsATVHeaderStd<TRow extends {}, TFilters extends {}> = {
  store: TableStore<TRow, TFilters>;
  dynamicProps: PropsATVDynamic;
  useSelection?: boolean;
};

export const ATVHeaderStd = observer(
  <TRow extends {}, TFilters extends {}>({
    store,
    useSelection,
    dynamicProps: { scroll },
  }: PropsATVHeaderStd<TRow, TFilters>) => {
    const columnRefs = useMemo(
      () =>
        store.finalColumns.reduce(
          (acc, { key }) => ({ ...acc, [key]: createRef<HTMLDivElement>() }),
          {} as Record<string, RefObject<HTMLDivElement>>,
        ),
      [store.columns],
    );

    const cells = [
      {
        key: "~selection",
        content: useSelection && store.rows.length > 0 && (
          <div
            className={classNames([
              styles.headerItem,
              styles.headerItemSelection,
            ])}
          >
            {store.selectionSettings.selectionType === "checkbox" ? (
              <TableSelectionCheckbox store={store} main />
            ) : (
              <div />
            )}
          </div>
        ),
      },
      ...store.finalColumns.map((column) => ({
        key: column.key,
        content: (
          <ATVHeaderCellStd
            column={column}
            refs={columnRefs}
            store={store}
            key={column.key}
          />
        ),
      })),
    ].filter((c) => !!c.content);
    const fixedCount = visibleFixedLeft(
      applyOrderStd(store, store.columns),
      store,
    );
    return (
      <ATVFreezeLine
        className={styles.tableHeader}
        fixedLeftCount={fixedCount > 0 ? fixedCount + 1 : 0}
        cells={cells}
        inScroll={scroll.x > 0}
      />
    );
  },
);
